import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import DeployContract from './pages/DeployContract';
import Admin from './pages/Admin';
import AboutSafety from './pages/AboutSafety';
import DeFi from './pages/DeFi';
import BuyTokens from './pages/BuyTokens';
import HowToEarn from './pages/HowToEarn';
import Academy from './pages/Academy';
import Course from './pages/Course';
import Lesson from './pages/Lesson';
import Competitions from './pages/Competitions';
import Certificates from './pages/Certificates';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Compliance from './pages/Compliance';
import SeedCapital from './pages/SeedCapital';
import LandingPageJP from './pages/LandingPageJP';
import CreditFacility from './pages/CreditFacility';
import AdminDashboardJP from './pages/AdminDashboardJP';
import TokenDistribution from './pages/TokenDistribution';
import CustomerLedger from './pages/CustomerLedger';
import Reports from './pages/Reports';
import TransactionLogs from './pages/TransactionLogs';
import MarketPrices from './pages/MarketPrices';
import TreasuryDashboard from './pages/TreasuryDashboard';
import AccreditationOnboarding from './pages/AccreditationOnboarding';
import CreditEnhancement from './pages/CreditEnhancement';
import InvestorGuide from './pages/InvestorGuide';
import PartnerLendersAdmin from './pages/PartnerLendersAdmin';
import PrivateLendingReserve from './pages/PrivateLendingReserve';
import AccreditationManagement from './pages/AccreditationManagement';
import ContractVerification from './pages/ContractVerification';
import AddressBook from './pages/AddressBook';
import ClaimRewards from './pages/ClaimRewards';
import FeeConversion from './pages/FeeConversion';
import TransferBeth from './pages/TransferBeth';
import MyTransactions from './pages/MyTransactions';
import MyAddressBook from './pages/MyAddressBook';
import PortfolioSummary from './pages/PortfolioSummary';
import Investors from './pages/Investors';
import WhitePaper from './pages/WhitePaper';
import InvestorApplications from './pages/InvestorApplications';
import TreasurySecurities from './pages/TreasurySecurities';
import AutoFinancing from './pages/AutoFinancing';
import MortgageRefinance from './pages/MortgageRefinance';
import NewAutoFinancing from './pages/NewAutoFinancing';
import AutoRefinance from './pages/AutoRefinance';
import NewMortgageFinancing from './pages/NewMortgageFinancing';
import LenderConsentPage from './pages/LenderConsentPage';
import AdminNovationDashboard from './pages/AdminNovationDashboard';
import AdminInvestorInquiries from './pages/AdminInvestorInquiries';
import AdminFinanceOrders from './pages/AdminFinanceOrders';
import Subscribe from './pages/PurchaseBETH';
import SubscriptionSuccess from './pages/PurchaseSuccess';
import SignDocument from './pages/SignDocument';
import LoanRepoManager from './pages/LoanRepoManager';
import HybridLedger from './pages/HybridLedger';
import TransactionManagement from './pages/TransactionManagement';
import { AuthProvider } from './context/AuthContext';
import { Web3Provider } from './context/Web3Context';
import { ConsumerAuthProvider } from './context/ConsumerAuthContext';
import { PASClientAuthProvider } from './context/PASClientAuthContext';
import { Toaster } from './components/ui/sonner';

// BETH Finance Pages
import BethFinanceLanding from './pages/beth-finance/BethFinanceLanding';
import ConsumerLogin from './pages/beth-finance/ConsumerLogin';
import ConsumerSignup from './pages/beth-finance/ConsumerSignup';
import ConsumerDashboard from './pages/beth-finance/ConsumerDashboard';
import CreditEnhancementApplication from './pages/beth-finance/CreditEnhancementApplication';
import PaymentSuccess from './pages/beth-finance/PaymentSuccess';
import LenderSubmission from './pages/beth-finance/LenderSubmission';
import PASReportOrder from './pages/beth-finance/PASReportOrder';
import PASSuccess from './pages/beth-finance/PASSuccess';

// BETHCOIN Exchange Market / PAS Client Portal Pages
import BethcoinLanding from './pages/pas/BethcoinLanding';
import PublicReserves from './pages/pas/PublicReserves';
import PASLogin from './pages/pas/PASLogin';
import PASSignup from './pages/pas/PASSignup';
import PASDashboard from './pages/pas/PASDashboard';
import PASPointOfSale from './pages/pas/PASPointOfSale';
import PASSwap from './pages/pas/PASSwap';
import PASDesk from './pages/pas/PASDesk';
import PASBankAccount from './pages/pas/PASBankAccount';
import CreateCheck from './pages/pas/CreateCheck';
import ViewCheck from './pages/pas/ViewCheck';
import PurchaseSuccessPAS from './pages/pas/PurchaseSuccess';
import EthPurchaseSuccess from './pages/pas/EthPurchaseSuccess';
import GasPurchaseSuccess from './pages/pas/GasPurchaseSuccess';
import PASAdminLogin from './pages/pas/PASAdminLogin';
import PASAdminDashboard from './pages/pas/PASAdminDashboard';
import VerifyCheck from './pages/pas/VerifyCheck';
import VerifyStatement from './pages/pas/VerifyStatement';
import { ActingBanner } from './components/pas/ActAs';
import PASBanking from './pages/pas/PASBanking';
import PASSubscriptionSuccess from './pages/pas/SubscriptionSuccess';
import TaxForms from './pages/pas/TaxForms';
import TaxFormDetail from './pages/pas/TaxFormDetail';
import CreditAgreement from './pages/pas/CreditAgreement';
import TreasuryCheckPrint from './pages/pas/TreasuryCheckPrint';
import VerifyTreasuryCheck from './pages/VerifyTreasuryCheck';
import ClaimTreasuryCheck from './pages/ClaimTreasuryCheck';
import ExchangeAgreements from './pages/pas/ExchangeAgreements';
import BethFinanceAdmin from './pages/BethFinanceAdmin';
import { PASAdminAuthProvider } from './context/PASAdminAuthContext';
import { SiteGate } from './components/SiteGate';
import { IntroSplash } from './components/IntroSplash';
import { BethBanner } from './components/BethBanner';
import { AnalyticsTracker } from './utils/analytics';

function PrivateRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem('token');
      setIsAuthenticated(!!token);
      setIsLoading(false);
    };
    checkToken();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#10b981]"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <Web3Provider>
        <ConsumerAuthProvider>
        <PASClientAuthProvider>
        <PASAdminAuthProvider>
        <div className="App">
          <IntroSplash />
          <ActingBanner />
          <BrowserRouter>
          <AnalyticsTracker>
          <SiteGate>
          <BethBanner />
          <Routes>
            {/* BETHCOIN Exchange Market is the main landing page */}
            <Route path="/" element={<BethcoinLanding />} />
            <Route path="/reserves" element={<PublicReserves />} />
            <Route path="/pas" element={<BethcoinLanding />} />
            <Route path="/pas/login" element={<PASLogin />} />
            <Route path="/pas/signup" element={<PASSignup />} />
            <Route path="/pas/dashboard" element={<PASDashboard />} />
            <Route path="/pas/pos" element={<PASPointOfSale />} />
            <Route path="/pas/swap" element={<PASSwap />} />
            <Route path="/pas/desk" element={<PASDesk />} />
            <Route path="/pas/bank" element={<PASBankAccount />} />
            <Route path="/pas/checks/create" element={<CreateCheck />} />
            <Route path="/pas/checks/:checkNumber" element={<ViewCheck />} />
            <Route path="/pas/purchase/success" element={<PurchaseSuccessPAS />} />
            <Route path="/pas/eth/success" element={<EthPurchaseSuccess />} />
            <Route path="/pas/gas/success" element={<GasPurchaseSuccess />} />
            <Route path="/pas/admin/login" element={<PASAdminLogin />} />
            <Route path="/pas/admin/dashboard" element={<PASAdminDashboard />} />
            <Route path="/verify-check/:checkNumber" element={<VerifyCheck />} />
            <Route path="/verify-statement/:documentId" element={<VerifyStatement />} />
            <Route path="/pas/banking" element={<PASBanking />} />
            <Route path="/pas/subscription/success" element={<PASSubscriptionSuccess />} />
            <Route path="/pas/tax-forms" element={<TaxForms />} />
            <Route path="/pas/tax-forms/:transactionId" element={<TaxFormDetail />} />
            <Route path="/pas/admin/tax-forms/:clientId/:transactionId" element={<TaxFormDetail />} />
            <Route path="/pas/credit-agreement" element={<CreditAgreement />} />
            <Route path="/pas/admin/credit-agreement/:creditLineId" element={<CreditAgreement />} />
            <Route path="/pas/treasury-check/:checkId" element={<TreasuryCheckPrint />} />
            <Route path="/pas/admin/treasury-check/:checkId" element={<TreasuryCheckPrint />} />
            <Route path="/pas/admin/check/:checkNumber" element={<ViewCheck />} />
            <Route path="/verify-treasury-check/:checkId" element={<VerifyTreasuryCheck />} />
            <Route path="/claim-treasury-check/:checkId" element={<ClaimTreasuryCheck />} />
            <Route path="/pas/exchange-agreements" element={<ExchangeAgreements />} />
            
            {/* Legacy/Other Pages */}
            <Route path="/home" element={<Home />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/register" element={<Signup />} />
            <Route path="/about" element={<AboutSafety />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/investor-guide" element={<InvestorGuide />} />
            <Route path="/investors" element={<LandingPageJP />} />
            
            {/* BETH Finance Routes (Consumer Portal) */}
            <Route path="/beth-finance" element={<BethFinanceLanding />} />
            <Route path="/beth-finance/login" element={<ConsumerLogin />} />
            <Route path="/beth-finance/signup" element={<ConsumerSignup />} />
            <Route path="/beth-finance/dashboard" element={<ConsumerDashboard />} />
            <Route path="/beth-finance/apply" element={<CreditEnhancementApplication />} />
            <Route path="/beth-finance/payment-success" element={<PaymentSuccess />} />
            <Route path="/beth-finance/lenders/:applicationId" element={<LenderSubmission />} />
            <Route path="/beth-finance/pas/order" element={<PASReportOrder />} />
            <Route path="/beth-finance/pas/success" element={<PASSuccess />} />
            
            {/* Public Consent Pages (no auth required) */}
            <Route path="/lender-consent/:agreementId" element={<LenderConsentPage />} />
            <Route path="/creditor-consent/:agreementId" element={<LenderConsentPage />} />
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/deploy" 
              element={
                <PrivateRoute>
                  <DeployContract />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <PrivateRoute>
                  <Admin />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/defi" 
              element={
                <PrivateRoute>
                  <DeFi />
                </PrivateRoute>
              } 
            />
            <Route path="/investors" element={<Investors />} />
            <Route path="/whitepaper" element={<WhitePaper />} />
            <Route 
              path="/buy-tokens" 
              element={
                <PrivateRoute>
                  <BuyTokens />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/how-to-earn" 
              element={
                <PrivateRoute>
                  <HowToEarn />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/academy" 
              element={
                <PrivateRoute>
                  <Academy />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/academy/courses/:courseId" 
              element={
                <PrivateRoute>
                  <Course />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/academy/lessons/:lessonId" 
              element={
                <PrivateRoute>
                  <Lesson />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/competitions" 
              element={
                <PrivateRoute>
                  <Competitions />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/certificates" 
              element={
                <PrivateRoute>
                  <Certificates />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/credit" 
              element={
                <PrivateRoute>
                  <CreditFacility />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/credit-facility" 
              element={
                <PrivateRoute>
                  <CreditFacility />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin-dashboard" 
              element={
                <PrivateRoute>
                  <AdminDashboardJP />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin/beth-finance" 
              element={
                <PrivateRoute>
                  <BethFinanceAdmin />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin/partner-lenders" 
              element={
                <PrivateRoute>
                  <PartnerLendersAdmin />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/distribute" 
              element={
                <PrivateRoute>
                  <TokenDistribution />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/customers" 
              element={
                <PrivateRoute>
                  <CustomerLedger />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/reports" 
              element={
                <PrivateRoute>
                  <Reports />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/transactions" 
              element={
                <PrivateRoute>
                  <TransactionLogs />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/market" 
              element={
                <PrivateRoute>
                  <MarketPrices />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/treasury" 
              element={
                <PrivateRoute>
                  <TreasuryDashboard />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/onboarding" 
              element={
                <PrivateRoute>
                  <AccreditationOnboarding />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/credit-enhancement" 
              element={
                <PrivateRoute>
                  <CreditEnhancement />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/treasury-securities" 
              element={
                <PrivateRoute>
                  <TreasurySecurities />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/auto-financing" 
              element={
                <PrivateRoute>
                  <AutoFinancing />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/mortgage-refinance" 
              element={
                <PrivateRoute>
                  <MortgageRefinance />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/new-auto-financing" 
              element={
                <PrivateRoute>
                  <NewAutoFinancing />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/auto-refinance" 
              element={
                <PrivateRoute>
                  <AutoRefinance />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/new-mortgage-financing" 
              element={
                <PrivateRoute>
                  <NewMortgageFinancing />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/subscribe" 
              element={<Subscribe />} 
            />
            <Route 
              path="/subscription-success" 
              element={<SubscriptionSuccess />} 
            />
            <Route 
              path="/lending-reserve" 
              element={
                <PrivateRoute>
                  <PrivateLendingReserve />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/accreditation-admin" 
              element={
                <PrivateRoute>
                  <AccreditationManagement />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/contract-verification" 
              element={
                <PrivateRoute>
                  <ContractVerification />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/address-book" 
              element={
                <PrivateRoute>
                  <AddressBook />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/rewards" 
              element={
                <PrivateRoute>
                  <ClaimRewards />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/fee-conversion" 
              element={
                <PrivateRoute>
                  <FeeConversion />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/transfer" 
              element={
                <PrivateRoute>
                  <TransferBeth />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/my-transactions" 
              element={
                <PrivateRoute>
                  <MyTransactions />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/my-addresses" 
              element={
                <PrivateRoute>
                  <MyAddressBook />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/portfolio" 
              element={
                <PrivateRoute>
                  <PortfolioSummary />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/investor-applications" 
              element={
                <PrivateRoute>
                  <InvestorApplications />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin/novation-dashboard" 
              element={
                <PrivateRoute>
                  <AdminNovationDashboard />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin/investor-inquiries" 
              element={
                <PrivateRoute>
                  <AdminInvestorInquiries />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin/finance-orders" 
              element={
                <PrivateRoute>
                  <AdminFinanceOrders />
                </PrivateRoute>
              } 
            />
            {/* Public signing route - no auth required */}
            <Route 
              path="/sign/:requestId" 
              element={<SignDocument />}
            />
            
            {/* Securities Lending & Repo */}
            <Route 
              path="/loan-repo" 
              element={<PrivateRoute><LoanRepoManager /></PrivateRoute>}
            />
            
            {/* Hybrid Ledger System */}
            <Route 
              path="/hybrid-ledger" 
              element={<PrivateRoute><HybridLedger /></PrivateRoute>}
            />
            
            {/* Securities Transaction Management */}
            <Route 
              path="/securities-transactions" 
              element={<PrivateRoute><TransactionManagement /></PrivateRoute>}
            />
            <Route 
              path="/securities-transactions/:transactionId" 
              element={<PrivateRoute><TransactionManagement /></PrivateRoute>}
            />
          </Routes>
          </SiteGate>
          </AnalyticsTracker>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
      </PASAdminAuthProvider>
      </PASClientAuthProvider>
      </ConsumerAuthProvider>
    </Web3Provider>
  </AuthProvider>
  );
}

export default App;